import { createFileRoute } from "@tanstack/react-router";
import { ChatOverview } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/chats/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<ChatOverview
			workspaceId={workspaceId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
